import RepositoryService from 'src/services/repository'

const resource = 'auth'

function login ({ companyLogin, userLogin, password }) {
  return RepositoryService.base.post(`${resource}/login`, {
    companyLogin,
    userLogin,
    password,
  })
}

function logout () {
  return RepositoryService.base.post(`${resource}/logout`)
}

function updateMe (editUserData) {
  return RepositoryService.base.patch(`${resource}/me`, editUserData)
}

function get () {
  return RepositoryService.crud.get(resource, 'me')
}

export default {
  login,
  logout,
  updateMe,
  get,
}
